<template>
    <div class="upcoming-interview-content card-box-style rounded rounded-30">
        <div class="main-title border-style d-flex justify-content-between align-items-center">
            <h3>Upcoming Interviews</h3>
            <a href="#" class="view-btn">View All</a>
        </div>

        <ul class="interviews-wrap">
            <li class="single-interview d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <img src="../../../assets/images/interview/interview-1.jpg" alt="interview-1">
                    <div class="interview-info ms-2">
                        <h4>Anderson Coopers</h4>
                        <span>11:00 AM - 01:30 PM</span>
                    </div>
                </div>
                <a href="#" class="call-btn">Make Call</a>
            </li>

            <li class="single-interview d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <img src="../../../assets/images/interview/interview-2.jpg" alt="interview-1">
                    <div class="interview-info ms-2">
                        <h4>Anderson Coopers</h4>
                        <span>11:00 AM - 01:30 PM</span>
                    </div>
                </div>
                <a href="#" class="call-btn">Make Call</a>
            </li>

            <li class="single-interview d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <img src="../../../assets/images/interview/interview-3.jpg" alt="interview-1">
                    <div class="interview-info ms-2">
                        <h4>Anderson Coopers</h4>
                        <span>11:00 AM - 01:30 PM</span>
                    </div>
                </div>
                <a href="#" class="call-btn">Make Call</a>
            </li>

            <li class="single-interview d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <img src="../../../assets/images/interview/interview-4.jpg" alt="interview-1">
                    <div class="interview-info ms-2">
                        <h4>Anderson Coopers</h4>
                        <span>11:00 AM - 01:30 PM</span>
                    </div>
                </div>
                <a href="#" class="call-btn">Make Call</a>
            </li>

            <li class="single-interview d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <img src="../../../assets/images/interview/interview-5.jpg" alt="interview-1">
                    <div class="interview-info ms-2">
                        <h4>Anderson Coopers</h4>
                        <span>11:00 AM - 01:30 PM</span>
                    </div>
                </div>
                <a href="#" class="call-btn">Make Call</a>
            </li>
        </ul>

        <div class="calendar-wrap style-three">
            <CalendarWrap />
        </div>
    </div>
</template>

<script>
import CalendarWrap from './CalendarWrap'

export default {
    name: 'UpcomingInterviews',
    components: {
        CalendarWrap,
    }
}
</script>

<style lang="scss">
.upcoming-group-lessons-content {
	overflow: hidden;
	.main-title {
		margin-bottom: 30px;
	}
}
.upcoming-interview-content {
	.main-title {
		padding-bottom: 30px;
		margin-bottom: 30px;
	}
	.interviews-wrap {
		padding: 0;
		margin-bottom: 50px;
		padding-bottom: 50px;
		border-bottom: 2px solid #F8FAFF;
		list-style-type: none;
		.single-interview {
			background: #FFFFFF 0% 0% no-repeat padding-box;
			border: 1px solid #DFE9FF;
			border-radius: 20px;
			padding: 30px;
			margin-bottom: 30px;
			img {
				border-radius: 50px;
				border: 3px solid var(--white-color);
				box-shadow: var(--box-shadow);
				max-width: 50px;
			}
			&:last-child {
				margin-bottom: 0;
			}
			h4 {
				font-size: 16px;
			}
			span {
				font-size: 12px;
			}
			.call-btn {
				background: #5C31D6 0% 0% no-repeat padding-box;
				border-radius: 7px;
				color: var(--white-color);
				font-size: 12px;
				padding: 8px 15px;
			}
		}
	}
}
.calendar-wrap {
    background-color: var(--white-color);
    box-shadow: var(--box-shadow);
    padding: 20px;
    border-radius: var(--border-radius);
    &.style-three {
        box-shadow: none;
        padding: 0;
    }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .upcoming-interview-content {
        .interviews-wrap {
            margin-bottom: 0;
            padding-bottom: 30px;
            .single-interview {
                padding: 15px;
                display: block !important;
                .call-btn {
                    display: block;
                    margin-top: 10px;
                    text-align: center;
                }
            }
        }
    }
	.upcoming-group-lessons-content {
        .main-title  {
            .view-btn {
                width: 80px;
                text-align: center;
            }
        }
    }
}

/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
    .upcoming-interview-content {
        .interviews-wrap {
            text-align: center;
            .single-interview {
                padding: 15px;
                flex: 0 0 auto;
                width: 47%;
                display: inline-block !important;
                margin: 0 5px;
                margin-bottom: 20px;
                text-align: left;
            }
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .upcoming-interview-content {
        .interviews-wrap {
            margin-bottom: 30px;
            padding-bottom: 30px;
            text-align: center;
            .single-interview {
                padding: 15px;
                flex: 0 0 auto;
                width: 47%;
                display: inline-block !important;
                margin: 0 5px;
                margin-bottom: 20px;
                text-align: left;
                .call-btn {
                    width: 100%;
                    display: block;
                    text-align: center;
                    margin-top: 10px;
                }
            }
        }
    }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .card-box-style {
        padding: 20px;
        &.rounded-30 {
            padding: 20px;
        }
    }
	.upcoming-group-lessons-content {
        .main-title.border-style {
            .view-btn {
                width: 80px;
                text-align: center;
            }
        }
    }
    .upcoming-interview-content {
        .interviews-wrap {
            .single-interview {
                padding: 15px;
                display: block !important;
                .call-btn {
                    display: block;
                    margin-top: 10px;
                    text-align: center;
                }
            }
        }
    }
}

/* Min width 1200px to Max width 1320px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
	.upcoming-group-lessons-content {
        overflow: hidden;
        .main-title {
            &.border-style {
                .view-btn {
                    width: 90px;
                    text-align: center;
                }
            }
        }
    }
    .upcoming-interview-content {
		.interviews-wrap {
            padding-bottom: 30px;
            margin-bottom: 30px;
			.single-interview {
                padding: 15px;
                display: block !important;
                text-align: center;
				.call-btn {
					text-align: center;
                    display: block;
                    margin-top: 10px;
				}
			}
		}
	}
}

/* Min width 1320px to Max width 1550px */
@media only screen and (min-width: 1320px) and (max-width: 1550px) {
    .upcoming-interview-content {
        .interviews-wrap {
            .single-interview {
                padding: 15px;
                display: block !important;
                text-align: center;
				text-align: left;
                .call-btn {
                    display: block;
					text-align: center;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>